import { makeStyles } from 'tss-react/mui';
import useWidth from '../../../../components/Hooks/useWidth';

type UseStylesProps = {
  screenHeight: number;
};

const useStyles = makeStyles<UseStylesProps>()((theme, { screenHeight }) => ({
  canvas: {
    backgroundColor: theme.palette.grey[100],
    width: '100%',
    height: `${screenHeight}px`,
    MozUserSelect: 'none',
    WebkitUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    textAlign: 'center',
  },
}));

const useCanvasStyle = () => {
  const { mobileWidth, activeBreakpoint } = useWidth();

  const widthMultiplier = {
    xs: 1,
    sm: 0.8,
    md: 0.8,
    lg: 0.7,
    xl: 0.4,
  };

  const screenWidth = window.innerWidth * widthMultiplier[activeBreakpoint];
  const screenHeight = window.innerHeight * (mobileWidth ? 0.17 : 0.25);

  const { classes: canvasClasses } = useStyles({ screenHeight });

  return {
    canvasClasses,
    screenWidth,
    screenHeight,
  };
};

export default useCanvasStyle;
